import _ from "lodash";
import { MODAL_STATUS } from "../../components/StatusModal/constants";

const statusModalStateReducer = (state, action) => {
  let newState = { ...state };
  switch (action.type) {
    case "initStateFromLocalStorage":
      const { status, shownAlready } = JSON.parse(
        localStorage.getItem("QBOMonerisConnectionStatus") || "{}"
      );
      if (shownAlready) {
        newState.status = null;
        newState.shownAlready = true;
      } else if (status) {
        // If there's a status to show and it hasn't been shown yet
        newState.status = status;
        newState.shownAlready = true; // Mark as shown immediately
      } else {
        newState.status = null;
        newState.shownAlready = false;
      }
      break;
    case "setStateFromModalStatus":
      // This is not a boolean because in the future we might have more statuses
      if (action.payload === MODAL_STATUS.success) {
        newState.status = action.payload;
        if (!newState.shownAlready) {
          newState.shownAlready = true;
        } else {
          newState.status = null;
        }
      } else if (action.payload === MODAL_STATUS.error) {
        newState.status = action.payload;
        newState.shownAlready = true;
      } else {
        newState.status = null;
        newState.shownAlready = false;
      }
      break;
    default:
      break;
  }
  localStorage.setItem(
    "QBOMonerisConnectionStatus",
    JSON.stringify({
      status: newState.status,
      shownAlready: newState.shownAlready,
    })
  );
  return _.isEqual(newState, state) ? state : newState;
};

const helper = { statusModalStateReducer };

export default helper;

// --- Change Plan localStorage utilities ---
const CHANGE_PLAN_STORAGE_KEY = "changePlanData";

export const getChangePlanData = () => {
  try {
    const data = localStorage.getItem(CHANGE_PLAN_STORAGE_KEY);
    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
};

export const setChangePlanData = (updates) => {
  const current = getChangePlanData() || {};
  localStorage.setItem(
    CHANGE_PLAN_STORAGE_KEY,
    JSON.stringify({ ...current, ...updates })
  );
};

export const clearChangePlanData = () => {
  localStorage.removeItem(CHANGE_PLAN_STORAGE_KEY);
};

export const isChangePlanStored = () => {
  const data = getChangePlanData();
  return data?.active === true;
};
